<template>
  <div class="ab-competitive ">
    <div class="ab_bg">
      <div class="warp">
        <div class="block-title" data-aos="fade">
          <!-- 区别于市面其他产品 -->
          {{ data['title'] }}
        </div>
        <div class="block-subtitle" data-aos="fade" data-aos-delay="100">
          <!-- 营销指标更容易把控 -->
          {{ data['subTitle'] }}
        </div>
        <div class="compare-both flex-row justify-between">
          <div class="ab-card" data-aos="fade-down" data-aos-delay="200">
            <div class="compare-a">
              <div class="title">
                <span class="fontsize36">{{ data['data'][0]['title'] }}</span>
              </div>
            </div>

            <div class="features">
              <a-row
                v-for="(item, index) in data['data'][0]['features']"
                :key="index"
              >
                <a-col :span="24">
                  <div class="features-item flex-row">
                    <div class="ab-point"></div>
                    <span class="fontsize20">{{ item }}</span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
          <div class="compare-icon" data-aos="zoom-in">
            <img src="~@/assets/product/插图_vs.png" />
          </div>
          <div class="ab-card" data-aos="fade-down" data-aos-delay="200">
            <div class="compare-b">
              <div class="title">
                <span class="fontsize36">{{ data['data'][1]['title'] }}</span>
              </div>
            </div>

            <div class="features">
              <a-row
                v-for="(item, index) in data['data'][1]['features']"
                :key="index"
              >
                <a-col :span="24">
                  <div class="features-item-b flex-row">
                    <div class="ab-point"></div>
                    <span class="fontsize20">{{ item }}</span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Object,
      default: {
        title: '区别于市面其他产品',
        subTitle: '营销指标更容易把控',
        data: [
          {
            title: '独立站平台',
            features: [
              // '网站底层架构差，合作结束网站收回产品单一',
              // '语言版本作为唯一特点国外浏览器排名不稳定',
              // '推广效果差询盘量稀少且不精准',
              // '客户流失率大',
              '入驻平台审核机制复杂，产品单一化',
              '恶性竞争严重，平台推广费用高',
              '实现品牌溢价难，需雇专业运营团队',
              '推送大量重复性广告询盘且不精准',
            ],
          },
          {
            title: 'AB客品牌营销',
            features: [
              // '智能建站安全稳定',
              // '合作结束静态站归用户站点覆盖面积广',
              // '产品体系丰富完善从本质上优化网站',
              // '安全信任度更高双重过滤精准有效',
              // '客户智能化管理建档',
              '流程简化，一套应用包含多个平台',
              '套餐价格透明，避免恶性投放竞争',
              '容易塑造品牌形象，全程托管式运营',
              '人工+智能双重筛选过滤，精准有效',
            ],
          },
        ],
      },
    },
  },
  data() {
    return {
      data: this.dataList,
    };
  },
};
</script>

<style lang="sass" scoped>
.ab_bg{
  background:url('~@/assets/product/vs_背景.png') top center;
    padding-top: 68px;
  padding-bottom: 74px;
    height: 100%;
    width: 100%;

}
.ab-competitive{

  // height: 730px;
  background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%) ;
  .block-title{
    height: 55px;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 55px;
    text-align: center;
  }

  .block-subtitle{

    text-align: center;
    padding-top: 10px;
    height: 27px;
    font-size: 20px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 27px;

    opacity: 0.8;
  }

  .compare-both{
    padding-top: 48px;
  }

  .ab-card{
    width: 700px;
    min-height: 450px;
    background: #FFFFFF;
    border-radius: 20px;
    .compare-a{
      background: #F9F1F2 url('~@/assets/product/c_b_a.png') 50px 0px no-repeat;
      border-radius: 20px 20px 0px 0px;

    }

    .compare-b{
      background: #E5F0FE url('~@/assets/product/c_b_a.png') 50px 0px  no-repeat;
      border-radius: 20px 20px 0px 0px;

    }

    .title{
      height: 100px;
      line-height: 120px;
      text-indent: 105px;

      span{
        height: 50px;

        font-family: AlibabaPuHuiTiM;
        color: #2B68FF;
        line-height: 50px;
      }
    }

    .features{
      // padding-left: 105px;
      // padding-top: 50px;
      padding-left: 15%;
      padding-top: 10%;
      padding-bottom: 10%;
    }

    .features-item{
      line-height: 60px;
      .ab-point{
        width: 6px;
        height: 6px;
         top: 26px;
        margin-right: 13px;
      }
      span{
        font-family: Alibaba-PuHuiTi-R;
        font-weight: normal;
        color: #666;
      }
    }

    .features-item-b{
      line-height: 60px;
      span{
        color:#666
      }
      .ab-point{
        background:url(~@/assets/product/pic_1.jpg) no-repeat;
        height:16px;
        width:16px;
        margin-top: 3px;
        background-size: contain;
      }
    }
  }

  .compare-icon{
    width: 130px;
    line-height: 450px;
    img{
      width: 130px;
    }
  }



}
</style>
